$(document).on('click', '.verplano', function (e) {
    e.preventDefault();

    let planta = String($(this).data('planta'));
    // Normaliza planta a la nomenclatura de tus mapas base
    if (planta === '-1') planta = '1';
    if (planta === 'ambas') planta = '0';

    const baseURL = `/storage/locales/mapa-general-${planta}.png`;

    // overlays viene como JSON en el atributo data-overlays
    let overlays = [];
    try {
        overlays = JSON.parse($(this).attr('data-overlays') || '[]');
    } catch(e) {
        overlays = [];
    }

    // Evita duplicados por si varios locales comparten la misma imagen
    overlays = [...new Set(overlays.filter(Boolean))];

    $('#mapaBase').attr('src', baseURL);

    const $capas = $('#capasContainer');
    $capas.empty();
    overlays.forEach(url => {
        const $img = $('<img>', { src: url, alt: 'capa tienda', class: 'capa-tienda' });
        $capas.append($img);
    });

    $('#planoModal').fadeIn();
});

// Cerrar modal
$(document).on('click', '.cerrar-modal, #planoModal', function (e) {
    if (e.target.id === 'planoModal' || $(e.target).hasClass('cerrar-modal')) {
        $('#planoModal').fadeOut();
    }
});
